<template>
  <sso-button
    v-bind="$props"
    v-slot="{ provider, text }"
  >
    <span class="btn__container">
      <span class="d-flex justify-content-start align-items-center">
        <img
          src="https://koalect-images.s3.eu-west-3.amazonaws.com/sso/vrt.svg"
          :alt="t('literal.logo_of_x', { x: provider })"
          height="18"
        >
      </span>

      <span class="btn__text">
        {{ text }}
      </span>
    </span>
  </sso-button>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'

import SsoButton from '&/atoms/SsoButton'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.btn {
  background: #020C29;

  &:hover {
    background: $black;
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr minmax(10px, 2fr) 1fr;
  }

  &__text {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 24px;
  }
}
</style>